import {DriverStatusEnum} from '@/services/api-clients';

export function driverStatusTagIconFilter(status: DriverStatusEnum): string {
  switch (status) {
    case DriverStatusEnum.Active: return 'mdi-account-plus';
    case DriverStatusEnum.Warning: return 'mdi-magnify';
    case DriverStatusEnum.New: return 'mdi-account-plus';
    case DriverStatusEnum.Problem: return 'mdi-alert-circle';
    case DriverStatusEnum.Inactive: return 'mdi-account-off';
    case DriverStatusEnum.WaitingForActivation: return 'mdi-clock-outline';
    case DriverStatusEnum.NoSettlementsInLast2Weeks: return 'mdi-cash-remove';
    case DriverStatusEnum.Bailiff: return 'mdi-scale-unbalanced';
    case DriverStatusEnum.Debtor: return 'mdi-cash-minus';
    case DriverStatusEnum.PaymentSuspension: return 'mdi-credit-card-off';
    case DriverStatusEnum.Fraud: return 'mdi-robber';
    case DriverStatusEnum.OfficeVisitRequired: return 'mdi-domain';
    case DriverStatusEnum.Duplicate: return 'mdi-account-alert';
    case DriverStatusEnum.FilesMissingAfterUserRegistration: return 'mdi-file-alert';
    case DriverStatusEnum.HasMobileApplication: return 'mdi-cellphone';
  }
}
